module.exports = __webpack_public_path__ + "img/rogers-waterfront.ff9e2baf.webp";